import * as Types from '../constants/Types';

export const getListVinWonderPrices = (filters) => ({ type: Types.VIN_WONDER_PRICE_LIST_ACTION, filters });
export const setListVinWonderPrices = (vinWonderPrices) => ({ type: Types.VIN_WONDER_PRICE_LIST_SUCCESS, vinWonderPrices});

export const getVinWonderPriceDetail = (id) => ({ type: Types.VIN_WONDER_PRICE_DETAIL_ACTION, id })
export const setVinWonderPriceDetail = (vinWonderPrice) => ({ type: Types.VIN_WONDER_PRICE_DETAIL_SUCCESS, vinWonderPrice });

export const updateVinWonderPriceDetail = (vinWonderPrice) => ({ type: Types.VIN_WONDER_PRICE_DETAIL_UPDATE_ACTION, vinWonderPrice });
export const createVinWonderPriceDetail = (vinWonderPrice) => ({ type: Types.VIN_WONDER_PRICE_DETAIL_CREATE_ACTION, vinWonderPrice });
export const deleteVinWonderPriceDetail = (vinWonderPrice, filters) => ({ type: Types.VIN_WONDER_PRICE_DETAIL_DELETE_ACTION, vinWonderPrice, filters });
